import {writable} from 'svelte/store';
import {OBJECTS} from "../lib/constants";

let chargeObject = {
    charge: null,
};

const {get, set, update, subscribe} = writable(chargeObject);

const charges = {
    set,
    update,
    subscribe,

    // create: (objects, data = null, closeCallback = null) => {
    //     if (objects && !Array.isArray(objects)) {
    //         objects = [objects];
    //     }
    //     if (!data) {
    //         data = {};
    //     }
    //     charges.update(obj => {
    //         obj.charge = {
    //             id: 0,
    //             objects,
    //             name: data.name || '',
    //             price: data.price || null,
    //             closeCallback,
    //         };
    //         return obj;
    //     });
    // },

     create: (object_type = OBJECTS.NONE, object_id = 0, data = null, closeCallback = null) => {
        if (!data) {
            data = {};
        }
        charges.update(obj => {
            obj.charge = {
                id: 0,
                object_type,
                object_id,
                name: data.name || '',
                price: data.price || null,
                client: data.client || null,
                project: data.project || null,
                closeCallback,
            };
            return obj;
        });
    },

    edit: (id, closeCallback) => {
        charges.update(obj => {
            obj.charge = {
                id,
                closeCallback,
            };
            return obj;
        });
    },

    clearEdit: () => {
        charges.update(obj => {
            obj.charge = null;
            return obj;
        });
    },
}

export default charges;